import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { Suspense, useEffect } from "react";
import LogRocket from "logrocket";
import { connect } from "react-redux";
import { Loader } from "./icons";
import { protectedRoutes, publicRoutes } from "./routes";
import PageNotFound from "./routes/PageNotFound";
import Redirect from "./routes/Redirect";
import ProtectedRoute from "./routes/ProtectedRoutes";
import { history } from "./redux/store";
import { IS_LOG_ROCKET_ON, REACT_APP_LOG_ROCKET_APP_ID } from "./helper/constant";
import { initAnalytics } from "./helper/analytics";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker/AnalyticsRouteTracker";

if (IS_LOG_ROCKET_ON && REACT_APP_LOG_ROCKET_APP_ID) {
  LogRocket.init(REACT_APP_LOG_ROCKET_APP_ID);
}

initAnalytics();

function App(props) {
  const { firstName, lastName, email, userId } = props ?? {};

  useEffect(() => {
    // To handle page refresh
    if (IS_LOG_ROCKET_ON && userId && firstName && lastName && email) {
      LogRocket.identify(userId, {
        name: `${firstName} ${lastName}`,
        email: email,
      });
    }
  }, [])
  window.addEventListener("popstate", () => {
    history.go(1);
  });
  return (
    <div>
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <Suspense
          fallback={
            <div className="flex flex-1 h-screen justify-center items-center">
              <Loader height={64} width={64} />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Redirect />} />
            <Route
              path="/hippa-consent"
              element={<Redirect to="/hipaa-consent" />}
            />
            {publicRoutes.map((route, i) => {
              return (
                <Route path={route.path} element={route.component} key={i} />
              );
            })}
            <Route element={<ProtectedRoute />}>
              {protectedRoutes.map((route, i) => {
                return (
                  <Route path={route.path} element={route.component} key={i} />
                );
              })}
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    ...state?.users?.userData,
  };
};

export default connect(mapStateToProps, null)(App);
